import {
  IFormAdser,
  IFormField,
  IFormRow,
  IFormSection,
  IUserAddress,
} from '@vestiaire/vc-address-form/src/interfaces/address.d';
import { ServiceError } from '@/types/service';
import { Result } from '@/types/common';
import { ClientItems } from '@/types/item';

export function mergeClientItems(results: Result<ServiceError, ClientItems>[]): ClientItems {
  return results.reduce(
    (data: ClientItems, result: Result<ServiceError, ClientItems>) => {
      return result.kind !== 'Ok'
        ? { ...data, hasMore: false }
        : { hasMore: result.data.hasMore, products: [...data.products, ...(result.data.products || [])] };
    },
    { products: [], hasMore: false },
  );
}

// THE BELOW CODE IS LEGACY, PLEASE CHECK THIS AGAIN
// I DO NOT HAVE TIME FOR THIS

export type ClientAddress = {
  district?: string;
  county?: string;
  country: string;
  province?: string;
  state?: string;
  phoneNumberPrefix: string;
} & Omit<IUserAddress, 'country' | 'state'>;

export function adserMapper(data: IFormAdser): ClientAddress | null {
  try {
    let adserObject = {};
    data.formSectionList?.forEach((section: IFormSection) => {
      section.formRowList?.forEach((row: IFormRow) => {
        if (row.mnemonic === 'hiddenRow') {
          return;
        }
        if (row.formFieldList.length > 1) {
          row.formFieldList.forEach((line: IFormField) => {
            adserObject = { ...adserObject, ...adserFieldMapper(line) };
          });
        } else {
          adserObject = {
            ...adserObject,
            ...adserFieldMapper(row.formFieldList[0]),
          };
        }
      });
    });
    // No choice - This legacy
    // eslint-disable-next-line
    return adserObject as ClientAddress;
  } catch {
    return null;
  }
}

export function adserFieldMapper(field: IFormField): {
  [param: string]: boolean | string | number;
} | null {
  try {
    const obj: { [param: string]: boolean | string | number } = {};

    if (field.mnemonic.includes('List')) {
      const fieldReadable = field.choiceList?.find((obj) => obj.value === field.value);
      if (fieldReadable != null) {
        obj[field.mnemonic.replace('List', '').replace('Choice', '')] = fieldReadable.textLabel;
        obj[`${field.mnemonic.replace('List', '').replace('Choice', '')}Value`] = field.value;
        return obj;
      }
    }

    obj[field.mnemonic] = field.value;
    return obj;
  } catch {
    return null;
  }
}

export function formatPhoneNumber(phoneNumber: string): string {
  phoneNumber = phoneNumber.replaceAll(' ', '');
  phoneNumber = phoneNumber.replaceAll('(0)', '');
  phoneNumber = phoneNumber.replaceAll('(', '');
  phoneNumber = phoneNumber.replaceAll(')', '');

  if (phoneNumber.length === 0) {
    return phoneNumber;
  }
  if (phoneNumber[0] === '+') {
    const list = phoneNumber.split('+');
    if (list.length <= 1) {
      return '';
    }
    return list[1];
  }
  return phoneNumber;
}
